import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=24a36b06&scoped=true&"
var script = {}
import style0 from "./TheLayout.vue?vue&type=style&index=0&id=24a36b06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a36b06",
  null
  
)

export default component.exports